/**
 * Identity Verification Decline Reason
 *
 * Matches Flutter's `IdentityVerificationDeclineReason` enum order EXACTLY.
 * Source: lib/domain/enums/identity_verification_decline_reason.dart
 * The user-friendly label per reason lives in l10n
 * (`l10n.inbox.notifications.identityDeclineReasons`), mirroring Flutter's
 * `IdentityVerificationDeclineReasonExtension.userFriendlyValue`.
 *
 * Numeric values match Flutter's `.index` (declineReason is stored as the enum
 * index in Firestore — see `identityVerificationInfoDto.declineReason`).
 */
export enum IdentityVerificationDeclineReason {
  unclearDocument = 0,
  unclearLiveness = 1,
  unclearUploadedFiles = 2,
  missmatchUploadedFiles = 3,
  missmatchUploadedFilesProfile = 4,
  premiumPackageExpired = 5,
  identityDataChanged = 6,
}
